import { useContext } from 'react';
import { SessionIdContext } from './SessionIdContextProvider';

export const useSessionId = (): string | undefined => {
  const sessionId = useContext(SessionIdContext);

  return sessionId;
};
